
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("e15Q8", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplateDetailsRelayPage", function () { return $3cabeed800ac8e7d$export$ed4c86e3dbd647b; });

var $loA2J = parcelRequire("loA2J");

var $78sex = parcelRequire("78sex");
const $3cabeed800ac8e7d$export$ed4c86e3dbd647b = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $78sex.ConfluenceTemplateDetailsRelayPageTemplate), {
        queryRef: queryRef
    });
};

});
parcelRegister("78sex", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplateDetailsRelayPageQuery", function () { return $7d7a3259636ee566$export$690b2909d81a5261; });
$parcel$export(module.exports, "getConfluenceTemplateDetailsRelayPageQueryVars", function () { return $7d7a3259636ee566$export$55ab657411300858; });
$parcel$export(module.exports, "ConfluenceTemplateDetailsRelayPageTemplate", function () { return $7d7a3259636ee566$export$ee61b52ae9fd1251; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $cunfD = parcelRequire("cunfD");

var $1XyNv = parcelRequire("1XyNv");

var $5VuC0 = parcelRequire("5VuC0");

var $4ktyF = parcelRequire("4ktyF");

var $lHB9W = parcelRequire("lHB9W");

var $3FBn4 = parcelRequire("3FBn4");

var $1MbAx = parcelRequire("1MbAx");

var $lGc56 = parcelRequire("lGc56");

var $a8pnN = parcelRequire("a8pnN");

var $3xvUi = parcelRequire("3xvUi");

var $jPdsy = parcelRequire("jPdsy");

var $fWQ89 = parcelRequire("fWQ89");

var $8b1Ol = parcelRequire("8b1Ol");
var $7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery;
const $7d7a3259636ee566$var$detailPageStyles = null;
const $7d7a3259636ee566$var$detailPageContentStyles = null;
const $7d7a3259636ee566$var$backLinkStyles = null;
const $7d7a3259636ee566$var$leftSectionStyles = null;
const $7d7a3259636ee566$var$rightSectionStyles = null;
const $7d7a3259636ee566$var$parseTemplateUrlSlug = (pathname)=>{
    const [urlSlug, maybeTemplatesSlug] = pathname.split("/").reverse();
    return urlSlug && maybeTemplatesSlug === "templates" ? urlSlug : "";
};

const $7d7a3259636ee566$export$690b2909d81a5261 = $7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery !== void 0 ? $7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery : ($7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery = (parcelRequire("2KyLQ")), $7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery.hash && $7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery.hash !== "58f05b29349913b5b21e570429855a37" && console.error("The definition of 'confluenceTemplateDetailsContentfulRelayPageQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery);
const $7d7a3259636ee566$export$55ab657411300858 = (location, partialVars)=>{
    var _partialVars_locale;
    const locale = (_partialVars_locale = partialVars === null || partialVars === void 0 ? void 0 : partialVars.locale) !== null && _partialVars_locale !== void 0 ? _partialVars_locale : (0, $a8pnN.parseQueryLocale)(location);
    var _partialVars_urlSlug;
    const urlSlug = (_partialVars_urlSlug = partialVars === null || partialVars === void 0 ? void 0 : partialVars.urlSlug) !== null && _partialVars_urlSlug !== void 0 ? _partialVars_urlSlug : $7d7a3259636ee566$var$parseTemplateUrlSlug(location.pathname);
    return {
        locale: locale,
        urlSlug: urlSlug
    };
};
const $7d7a3259636ee566$var$DetailPageContentRelay = ({ queryRef: queryRef })=>{
    const { templates: templates } = (0, $hOqV7.usePreloadedQuery)($7d7a3259636ee566$export$690b2909d81a5261, queryRef);
    const template = (0, $lHB9W.expectContent)(templates === null || templates === void 0 ? void 0 : templates.items[0]);
    const intl = (0, $f6qj2.default)();
    const templatesLink = (0, $3FBn4.useLocalizedHref)("/software/confluence/templates");
    const linkText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.backLink.cfind.1508",
        defaultMessage: "Explore all Confluence templates"
    });
    const backAriaLabel = (0, $1XyNv.ConfluenceTemplateMessages).searchBackAriaLabel.defaultMessage;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "confluence-template-details-page",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _1bah1h6o _2lx21bp4 _4cvr1h6o _bozg7vkz _y4ti7vkz"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _zulpd6z3 _1bah1h6o _p12f1osq _1gde1bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _1bsb1feq _1q5188uy _1pfhj6h1 _4t3i1osq _152tidpf _tnru1wug _v7367vkz _chtu7vkz _13zmh2mm _1rfm1osq _1rqi1if8"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_syaz9sh9 _1wyb7vkz _k48pbfng _1dyz131x _p12f6ecz _ca0q8vuz _u5f3idpf _n3td8vuz _19bvidpf _1bsb1osq"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", (0, $6iHNw._)((0, $7Knp0._)({
                                    href: templatesLink,
                                    "aria-label": backAriaLabel
                                }, (0, $5VuC0.ConfluenceTemplateAnalytics).searchBackButton()), {
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $cunfD.LeftArrowIcon), {
                                            size: "13"
                                        }),
                                        linkText
                                    ]
                                }))
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fWQ89.TemplateHeaderSection), {
                                template: template
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8b1Ol.TemplateKeyFeaturesSection), {
                                template: template
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3xvUi.TemplateCategorySection), {
                                template: template
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "data-testid": "TemplateDetailsBody-top",
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _1q51bv7e _1bsborz4 _v7367vkz _chtu7vkz _1u2qidpf _1rfm1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jPdsy.TemplateDetailsSection), {
                            template: template
                        })
                    })
                ]
            })
        })
    });
};
const $7d7a3259636ee566$export$d11f6c32a9aaae4d = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lGc56.SharedHeaderFooterContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)($7d7a3259636ee566$var$DetailPageContentRelay, {
                    queryRef: queryRef
                })
            })
        })
    });
};
const $7d7a3259636ee566$export$ee61b52ae9fd1251 = (0, $1MbAx.withFeatureExposed)("template-details-page-template-details-seo-v2", "enrolled", $7d7a3259636ee566$export$d11f6c32a9aaae4d);

});
parcelRegister("3xvUi", function(module, exports) {

$parcel$export(module.exports, "TemplateCategorySection", function () { return $f4e32fb04d5369a7$export$238f728cc1d4638a; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $8xSOc = parcelRequire("8xSOc");

var $4VhzM = parcelRequire("4VhzM");
var $f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment;
const $f4e32fb04d5369a7$var$WHITEBOARD_TEMPLATE_ID = "1HlskYfRNciSnQ02SDhCPs";
const $f4e32fb04d5369a7$var$templateCategorySectionStyles = null;
const $f4e32fb04d5369a7$var$headingStyles = null;
const $f4e32fb04d5369a7$var$categoryContainerStyles = null;
const $f4e32fb04d5369a7$var$categoriesColumnStyles = null;

const $f4e32fb04d5369a7$var$TemplateCategorySectionRelayFragment = $f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment !== void 0 ? $f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment : ($f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment = (parcelRequire("kzvZb")), $f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment.hash && $f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment.hash !== "488fa70f5b471114a1118928e06ba1f2" && console.error("The definition of 'templateCategorySectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment); // eslint-disable-next-line complexity
const $f4e32fb04d5369a7$export$238f728cc1d4638a = ({ template: template })=>{
    var _data_categories, _data_templateTypeCollection, _type_sys;
    const data = (0, $hOqV7.useFragment)($f4e32fb04d5369a7$var$TemplateCategorySectionRelayFragment, template);
    const categories = (data === null || data === void 0 ? void 0 : (_data_categories = data.categories) === null || _data_categories === void 0 ? void 0 : _data_categories.items) || [];
    const templateType = (data === null || data === void 0 ? void 0 : (_data_templateTypeCollection = data.templateTypeCollection) === null || _data_templateTypeCollection === void 0 ? void 0 : _data_templateTypeCollection.items) || [];
    const intl = (0, $f6qj2.default)();
    const categoryText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.categories.heading",
        defaultMessage: "CATEGORIES"
    });
    const experimentCategories = (categories !== null && categories !== void 0 ? categories : []).filter(// eslint-disable-next-line complexity
    (category)=>(category === null || category === void 0 ? void 0 : category.urlSlug) === "recommended" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "project-management" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "software-development-and-it" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "product-management" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "marketing-and-sales" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "design" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "finance-and-operations" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "human-resources");
    var _templateType_;
    const type = (_templateType_ = templateType === null || templateType === void 0 ? void 0 : templateType[0]) !== null && _templateType_ !== void 0 ? _templateType_ : {
        id: null,
        templateTypeName: null
    };
    const templateTypeKey = "sys" in type && ((_type_sys = type.sys) === null || _type_sys === void 0 ? void 0 : _type_sys.id) === $f4e32fb04d5369a7$var$WHITEBOARD_TEMPLATE_ID ? (0, $4VhzM.TemplateType).Whiteboard : (0, $4VhzM.TemplateType).Page;
    var _type_templateTypeNameExternal;
    const templateTypeLabel = "templateTypeNameExternal" in type ? (_type_templateTypeNameExternal = type.templateTypeNameExternal) !== null && _type_templateTypeNameExternal !== void 0 ? _type_templateTypeNameExternal : (0, $4VhzM.TemplateType).Page : (0, $4VhzM.TemplateType).Page;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_syaz19tk _1wyboqnp _k48p1nn1 _1dyzt94y _6rth1tcg _1pfh1f4h"
                ]),
                children: categoryText
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    experimentCategories.map((category)=>{
                        var _category_sys;
                        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c116y _4t3izwfg _85i57vkz"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                                appearance: "inprogress",
                                children: category === null || category === void 0 ? void 0 : category.categoryNameExternal
                            })
                        }, category === null || category === void 0 ? void 0 : (_category_sys = category.sys) === null || _category_sys === void 0 ? void 0 : _category_sys.id);
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c116y _4t3izwfg _85i57vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                            appearance: templateTypeKey === (0, $4VhzM.TemplateType).Page ? "inprogress" : "success",
                            isBold: true,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "confluence.templates.detail.template.type",
                                defaultMessage: `{templateType} template`,
                                values: {
                                    templateType: templateTypeLabel
                                }
                            })
                        })
                    }, templateTypeKey)
                ]
            })
        ]
    });
};

});
parcelRegister("kzvZb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $80c5292c0319e213$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<0604e3f78425700337e1ded3f9b5b1cc>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $80c5292c0319e213$var$node = function() {
    var v0 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "templateCategorySectionContentfulRelayFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateTypeCollection",
                "kind": "LinkedField",
                "name": "templateTypeCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaxonomyTemplateType",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "templateTypeNameExternal",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": "categories",
                "args": null,
                "concreteType": "ProductTemplateCategoryCollection",
                "kind": "LinkedField",
                "name": "categoryCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaxonomyTemplateCategory",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "categoryNameExternal",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urlSlug",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "ProductTemplate",
        "abstractKey": null
    };
}();
$80c5292c0319e213$var$node.hash = "488fa70f5b471114a1118928e06ba1f2";
var $80c5292c0319e213$export$2e2bcd8739ae039 = $80c5292c0319e213$var$node;

});


parcelRegister("jPdsy", function(module, exports) {

$parcel$export(module.exports, "TemplateDetailsSection", function () { return $12d781c1a584bab2$export$1a14eb006a5f8a7b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");

var $95kuv = parcelRequire("95kuv");

var $iKQQs = parcelRequire("iKQQs");

var $afxk9 = parcelRequire("afxk9");

var $267RQ = parcelRequire("267RQ");

var $9AFPk = parcelRequire("9AFPk");
var $12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment;
const $12d781c1a584bab2$var$WHITEBOARD_TEMPLATE_ID = "1HlskYfRNciSnQ02SDhCPs";
const $12d781c1a584bab2$var$templateDetailsSectionStyles = null;
const $12d781c1a584bab2$var$ctaButtonContainerStyles = null;
const $12d781c1a584bab2$var$previewSectionStyles = null;

const $12d781c1a584bab2$var$TemplateDetailsSectionFragment = $12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment !== void 0 ? $12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment : ($12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment = (parcelRequire("aElNK")), $12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment.hash && $12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment.hash !== "e8b8a2fa5d16d077e413ac61f87dea66" && console.error("The definition of 'templateDetailsSectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment);
const $12d781c1a584bab2$export$1a14eb006a5f8a7b = ({ template: templateRef })=>{
    var _templateTypeCollection_items__sys, _templateTypeCollection_items_, _templateTypeCollection_items;
    const template = (0, $hOqV7.useFragment)($12d781c1a584bab2$var$TemplateDetailsSectionFragment, templateRef);
    const { pluginModuleKey: pluginModuleKey, templateNameExternal: templateNameExternal, templateTypeCollection: templateTypeCollection } = template;
    const { openModalForTemplate: openModalForTemplate } = (0, $gkV6l.useSiteSelectorContext)();
    const buttonUseTemplateClicked = ()=>{
        openModalForTemplate({
            templateId: pluginModuleKey !== null && pluginModuleKey !== void 0 ? pluginModuleKey : "",
            templateName: templateNameExternal !== null && templateNameExternal !== void 0 ? templateNameExternal : "",
            productKey: (0, $i8kxh.ProductKeys).CONFLUENCE
        });
    };
    const navigateToSignupClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        buttonUseTemplateClicked();
    };
    const navigateToSignupKeyDown = (event)=>{
        if (event.code === "Space" || event.code === "Enter") {
            event.stopPropagation();
            event.preventDefault();
            buttonUseTemplateClicked();
        }
    };
    const isWhiteBoardTemplate = (templateTypeCollection === null || templateTypeCollection === void 0 ? void 0 : (_templateTypeCollection_items = templateTypeCollection.items) === null || _templateTypeCollection_items === void 0 ? void 0 : (_templateTypeCollection_items_ = _templateTypeCollection_items[0]) === null || _templateTypeCollection_items_ === void 0 ? void 0 : (_templateTypeCollection_items__sys = _templateTypeCollection_items_.sys) === null || _templateTypeCollection_items__sys === void 0 ? void 0 : _templateTypeCollection_items__sys.id) === $12d781c1a584bab2$var$WHITEBOARD_TEMPLATE_ID;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "TemplateDetailsSection",
        className: (0, $esG4f.default)([
            "_tnru1wug"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                onClick: isWhiteBoardTemplate ? undefined : navigateToSignupClick,
                onKeyDown: isWhiteBoardTemplate ? undefined : navigateToSignupKeyDown,
                role: "img",
                "aria-label": "Template preview" // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                ,
                tabIndex: 0,
                className: (0, $esG4f.default)([
                    !isWhiteBoardTemplate && "_80omtlke"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $afxk9.TemplatePreview), {
                    template: template
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $iKQQs.TemplateDescription), {
                template: template
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $9AFPk.TemplateTabbedSection), {
                template: template
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _suga1ule _476dvbgk"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $95kuv.TemplateCtaButtons), {
                    name: templateNameExternal !== null && templateNameExternal !== void 0 ? templateNameExternal : "",
                    pluginModuleKey: pluginModuleKey !== null && pluginModuleKey !== void 0 ? pluginModuleKey : ""
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $267RQ.TemplateRelatedTemplates), {
                template: template
            })
        ]
    });
};

});
parcelRegister("iKQQs", function(module, exports) {

$parcel$export(module.exports, "TemplateDescription", function () { return $d21ff73d1b3f26b7$export$809977f0794a1530; });

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");

var $cyfPT = parcelRequire("cyfPT");

var $A9zZc = parcelRequire("A9zZc");
var $d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment;

const $d21ff73d1b3f26b7$var$TemplateDescriptionRelayFragment = $d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment !== void 0 ? $d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment : ($d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment = (parcelRequire("ly6OB")), $d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment.hash && $d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment.hash !== "feb20f99c8568003e487a1eac2d28713" && console.error("The definition of 'templateDescriptionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment);
const $d21ff73d1b3f26b7$export$809977f0794a1530 = ({ template: template })=>{
    const { aboutThisTemplate: aboutThisTemplate } = (0, $hOqV7.useFragment)($d21ff73d1b3f26b7$var$TemplateDescriptionRelayFragment, template);
    if (!aboutThisTemplate) return null;
    const aboutThisTemplateString = (aboutThisTemplate === null || aboutThisTemplate === void 0 ? void 0 : aboutThisTemplate.json) ? (0, $cyfPT.richTextToHTML)(aboutThisTemplate.json) : "";
    const renderDescription = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
            innerHTML: aboutThisTemplateString
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        "data-testid": "confluence-template-details-template-description",
        children: renderDescription()
    });
};

});
parcelRegister("ly6OB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $bc0d45e37eeb524f$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<c868d6a326acca2cad7e84c95fb71b5f>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bc0d45e37eeb524f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateDescriptionContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplateAboutThisTemplate",
            "kind": "LinkedField",
            "name": "aboutThisTemplate",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "json",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$bc0d45e37eeb524f$var$node.hash = "feb20f99c8568003e487a1eac2d28713";
var $bc0d45e37eeb524f$export$2e2bcd8739ae039 = $bc0d45e37eeb524f$var$node;

});


parcelRegister("afxk9", function(module, exports) {

$parcel$export(module.exports, "TemplatePreview", function () { return $5deb3b319bdd5a59$export$48a171bbad47b95a; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $1IKTR = parcelRequire("1IKTR");

var $4VhzM = parcelRequire("4VhzM");
var $5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment;
const $5deb3b319bdd5a59$var$WHITEBOARD_TEMPLATE_ID = "1HlskYfRNciSnQ02SDhCPs";
const $5deb3b319bdd5a59$var$templatePreviewSection = null;
const $5deb3b319bdd5a59$var$previewBackgroundContainer = null;
const $5deb3b319bdd5a59$var$relativePosition = null;

const $5deb3b319bdd5a59$var$TemplatePreviewRelayFragment = $5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment !== void 0 ? $5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment : ($5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment = (parcelRequire("jX9s2")), $5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment.hash && $5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment.hash !== "dad8d8814494331f36c5867d050c8524" && console.error("The definition of 'templatePreviewContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment);
const $5deb3b319bdd5a59$export$48a171bbad47b95a = ({ template: template })=>{
    var _templateTypeCollection_items__sys, _templateTypeCollection_items_;
    const { templateNameExternal: templateNameExternal, templateTypeCollection: templateTypeCollection, templatePreviews: templatePreviews } = (0, $hOqV7.useFragment)($5deb3b319bdd5a59$var$TemplatePreviewRelayFragment, template);
    var _templatePreviews_items_;
    const templatePreview = (_templatePreviews_items_ = templatePreviews === null || templatePreviews === void 0 ? void 0 : templatePreviews.items[0]) !== null && _templatePreviews_items_ !== void 0 ? _templatePreviews_items_ : null;
    if (!templatePreview) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_85i57vkz _y3gn1h6o"
        ]),
        children: templatePreview && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm _85i5ckbl _y4tigktf _bozggktf"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _mnhno812 _9ha51oh5 _3s7lz8o0 _zl7jzoqa"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1IKTR.TemplatePreviewWindow), {
                    url: templatePreview.url || "",
                    alt: templateNameExternal !== null && templateNameExternal !== void 0 ? templateNameExternal : "",
                    templateType: (templateTypeCollection === null || templateTypeCollection === void 0 ? void 0 : (_templateTypeCollection_items_ = templateTypeCollection.items[0]) === null || _templateTypeCollection_items_ === void 0 ? void 0 : (_templateTypeCollection_items__sys = _templateTypeCollection_items_.sys) === null || _templateTypeCollection_items__sys === void 0 ? void 0 : _templateTypeCollection_items__sys.id) === $5deb3b319bdd5a59$var$WHITEBOARD_TEMPLATE_ID ? (0, $4VhzM.TemplateType).Whiteboard : (0, $4VhzM.TemplateType).Page
                })
            })
        })
    });
};

});
parcelRegister("jX9s2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3acad4a414841778$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<90d50cdcf380b3a9fe613330e6d712ac>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3acad4a414841778$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templatePreviewContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplateTemplateTypeCollection",
            "kind": "LinkedField",
            "name": "templateTypeCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaxonomyTemplateType",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sys",
                            "kind": "LinkedField",
                            "name": "sys",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": "templatePreviews",
            "args": null,
            "concreteType": "AssetCollection",
            "kind": "LinkedField",
            "name": "templatePreviewCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$3acad4a414841778$var$node.hash = "dad8d8814494331f36c5867d050c8524";
var $3acad4a414841778$export$2e2bcd8739ae039 = $3acad4a414841778$var$node;

});


parcelRegister("267RQ", function(module, exports) {

$parcel$export(module.exports, "TemplateRelatedTemplates", function () { return $cac52137e6d04ec8$export$7e056a1cce206233; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $1XyNv = parcelRequire("1XyNv");

var $5ohHq = parcelRequire("5ohHq");

var $iIoKV = parcelRequire("iIoKV");
var $cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment;
const $cac52137e6d04ec8$var$tabbedSectionHeading = null;
const $cac52137e6d04ec8$var$relatedTemplatesStyles = null;
const $cac52137e6d04ec8$var$relatedTemplatesMobileStyles = null;
const $cac52137e6d04ec8$var$relatedSectionStyles = null;
const $cac52137e6d04ec8$var$buttonLeft = null;
const $cac52137e6d04ec8$var$buttonRight = null;
const $cac52137e6d04ec8$var$buttonLeftArrow = null;
const $cac52137e6d04ec8$var$buttonRightArrow = null;
const $cac52137e6d04ec8$var$LeftArrow = ({ onClick: onClick, label: label })=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: onClick,
        "aria-label": label,
        className: (0, $esG4f.default)([
            "_bfhkcd5j _1e0c1ule _vchhusvi _1e02idpf _152t1ssb _1bsbzwfg _4t3izwfg _19itglyw _16qs1a7r _t9ec1krs _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazrbzz _vwz4an13 _1pbykb7n _1wpz1h6o"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_t9eczk8b _1bsb1crf _4t3i1crf _1e0c1o8l _vwz4idpf _kqswstnw _1pfhyjp0 _ahbqmyb0 _vchhusvi _mqm2pqxa _191wpqxa _1wyb7vkz"
            ])
        })
    });
const $cac52137e6d04ec8$var$RightArrow = ({ onClick: onClick, label: label })=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: onClick,
        "aria-label": label,
        className: (0, $esG4f.default)([
            "_bfhkcd5j _vchhusvi _1e0c1ule _rjxpidpf _152t1ssb _1bsbzwfg _4t3izwfg _19itglyw _16qs1a7r _t9ec1krs _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazrbzz _vwz4an13 _1pbykb7n _1wpz1h6o"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_t9ec1hke _1bsb1crf _4t3i1crf _1e0c1o8l _vwz4idpf _kqswstnw _1pfhyjp0 _ahbq1bs0 _vchhusvi _mqm2pqxa _191wpqxa _1wyb7vkz"
            ])
        })
    });

const $cac52137e6d04ec8$var$TemplateRelatedTemplatesRelayFragment = $cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment !== void 0 ? $cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment : ($cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment = (parcelRequire("PjKSP")), $cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment.hash && $cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment.hash !== "6fdcb09848f43d30eb54f40624d96941" && console.error("The definition of 'templateRelatedTemplatesContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment);
const $cac52137e6d04ec8$export$7e056a1cce206233 = ({ template: template })=>{
    const { relatedTemplatesCollection: relatedTemplatesCollection } = (0, $hOqV7.useFragment)($cac52137e6d04ec8$var$TemplateRelatedTemplatesRelayFragment, template);
    const intl = (0, $f6qj2.default)();
    const previousLabel = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).carouselPreviousLabel);
    const nextLabel = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).carouselNextLabel);
    const [currentIndex, setCurrentIndex] = (0, $iSvIT.useState)(0);
    const hasRelatedTemplates = relatedTemplatesCollection && relatedTemplatesCollection.items.length > 0;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1pfh68cl _ahbq1wug _12l21wug _476dvbgk"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41pz4 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1cqs1k8s _1bys1m1q"
                ]),
                style: {
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $1XyNv.ConfluenceTemplateMessages).relatedTemplatesTitle))
            }),
            hasRelatedTemplates && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0cglyw _dm251txw _pdlmzwfg"
                        ]),
                        children: [
                            currentIndex !== 0 && /*#__PURE__*/ (0, $loA2J.jsx)($cac52137e6d04ec8$var$LeftArrow, {
                                label: previousLabel,
                                onClick: ()=>{
                                    setCurrentIndex((prevIndex)=>(prevIndex - 1 + relatedTemplatesCollection.items.length) % relatedTemplatesCollection.items.length);
                                }
                            }),
                            relatedTemplatesCollection.items.slice(currentIndex, currentIndex + 2).map((relatedTemplate)=>{
                                var _relatedTemplate_sys;
                                return relatedTemplate && /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iIoKV.TemplateCard), {
                                        template: relatedTemplate
                                    })
                                }, (_relatedTemplate_sys = relatedTemplate.sys) === null || _relatedTemplate_sys === void 0 ? void 0 : _relatedTemplate_sys.id);
                            }),
                            currentIndex + 2 < relatedTemplatesCollection.items.length && /*#__PURE__*/ (0, $loA2J.jsx)($cac52137e6d04ec8$var$RightArrow, {
                                label: nextLabel,
                                onClick: ()=>{
                                    setCurrentIndex((prevIndex)=>(prevIndex + 1) % relatedTemplatesCollection.items.length);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _1e0c1txw _1n261g80 _zulpzwfg _dm25glyw"
                        ]),
                        children: relatedTemplatesCollection.items.map((relatedTemplate)=>{
                            var _relatedTemplate_sys;
                            return relatedTemplate && /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iIoKV.TemplateCard), {
                                    template: relatedTemplate
                                })
                            }, (_relatedTemplate_sys = relatedTemplate.sys) === null || _relatedTemplate_sys === void 0 ? void 0 : _relatedTemplate_sys.id);
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("PjKSP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4c80818db458ed37$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<5e5e20a65fa473102e66633a871353f8>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4c80818db458ed37$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateRelatedTemplatesContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplateRelatedTemplatesCollection",
            "kind": "LinkedField",
            "name": "relatedTemplatesCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductTemplate",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sys",
                            "kind": "LinkedField",
                            "name": "sys",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "templateCardContentfulRelayFragment"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$4c80818db458ed37$var$node.hash = "6fdcb09848f43d30eb54f40624d96941";
var $4c80818db458ed37$export$2e2bcd8739ae039 = $4c80818db458ed37$var$node;

});


parcelRegister("9AFPk", function(module, exports) {

$parcel$export(module.exports, "TemplateTabbedSection", function () { return $6c189e34a93e2bd8$export$c76d52df442babb1; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $cyfPT = parcelRequire("cyfPT");

var $cutM5 = parcelRequire("cutM5");

var $A9zZc = parcelRequire("A9zZc");

var $cRwVc = parcelRequire("cRwVc");

var $9CA5V = parcelRequire("9CA5V");

var $cdeeW = parcelRequire("cdeeW");
var $6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment;
const $6c189e34a93e2bd8$var$tabStyles = null;
const $6c189e34a93e2bd8$var$currentStyle = null;
const $6c189e34a93e2bd8$var$tabSectionStyle = null;
const $6c189e34a93e2bd8$var$sectionStyles = null;
const $6c189e34a93e2bd8$var$styles = null;
const $6c189e34a93e2bd8$var$TabHeading = ({ title: title, isSelected: isSelected })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_bfhk150w _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1yt41ois _2rko17td _80omtlke _19itzv82 _1wybf6fq _bfw78djs _irr31ybm _30l317la",
            isSelected && "_19it8djs _bfhk1ybm _syaz17la",
            "h5"
        ]),
        style: {
            "--_8nj8hf": (0, $43MIc.default)((0, $cRwVc.default)("color.neutral.light200")),
            "--_514je1": (0, $43MIc.default)((0, $cRwVc.default)("corner.radius.pill")),
            "--_1r6llbg": (0, $43MIc.default)((0, $cRwVc.default)("color.primary.blue")),
            "--_1hkddbi": (0, $43MIc.default)((0, $cRwVc.default)("color.extended.blue100"))
        },
        children: title
    });
};

const $6c189e34a93e2bd8$var$TemplateTabbedSectionRelayFragment = $6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment !== void 0 ? $6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment : ($6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment = (parcelRequire("1RYwV")), $6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment.hash && $6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment.hash !== "9e2878135e8f926d46ac10f3a93bce05" && console.error("The definition of 'templateTabbedSectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment); // eslint-disable-next-line complexity
const $6c189e34a93e2bd8$export$c76d52df442babb1 = ({ template: templateRef })=>{
    var _template_templateOverviewCollection, _template_templateOverviewCollection_items, _template_templateOverviewCollection1, _template_templateBenefitsCollection, _template_templateBenefitsCollection1, _template_templateBenefitsCollection_items, _template_templateBenefitsCollection2, _template_howToUseThisTemplateCollection, _template_howToUseThisTemplateCollection1, _template_howToUseThisTemplateCollection_items, _template_howToUseThisTemplateCollection2, _template_templateProductRationaleCollection, _template_templateProductRationaleCollection_items, _template_templateProductRationaleCollection1;
    const intl = (0, $f6qj2.default)();
    const template = (0, $hOqV7.useFragment)($6c189e34a93e2bd8$var$TemplateTabbedSectionRelayFragment, templateRef);
    const tabs = [
        {
            id: "tab1",
            title: intl.formatMessage({
                id: "ConfluenceTemplateMessages.tabs.overview.cfind.1508",
                defaultMessage: "Overview"
            }),
            hide: !((_template_templateOverviewCollection = template.templateOverviewCollection) === null || _template_templateOverviewCollection === void 0 ? void 0 : _template_templateOverviewCollection.items[0]),
            component: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                className: (0, $esG4f.default)([
                    "_1pfh8vuz"
                ]),
                children: (_template_templateOverviewCollection1 = template.templateOverviewCollection) === null || _template_templateOverviewCollection1 === void 0 ? void 0 : (_template_templateOverviewCollection_items = _template_templateOverviewCollection1.items) === null || _template_templateOverviewCollection_items === void 0 ? void 0 : _template_templateOverviewCollection_items.map((overview, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                                ]),
                                children: overview === null || overview === void 0 ? void 0 : overview.overviewTitle
                            }),
                            (overview === null || overview === void 0 ? void 0 : overview.overviewDescription) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                                innerHTML: (0, $cyfPT.richTextToHTML)(overview === null || overview === void 0 ? void 0 : overview.overviewDescription.json)
                            })
                        ]
                    }, `overview-${index}`))
            })
        },
        {
            id: "tab2",
            title: intl.formatMessage({
                id: "ConfluenceTemplateMessages.tabs.benefits.cfind.1508",
                defaultMessage: "Benefits"
            }),
            hide: !((_template_templateBenefitsCollection = template.templateBenefitsCollection) === null || _template_templateBenefitsCollection === void 0 ? void 0 : _template_templateBenefitsCollection.items) || ((_template_templateBenefitsCollection1 = template.templateBenefitsCollection) === null || _template_templateBenefitsCollection1 === void 0 ? void 0 : _template_templateBenefitsCollection1.items.length) === 0,
            component: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                children: (_template_templateBenefitsCollection2 = template.templateBenefitsCollection) === null || _template_templateBenefitsCollection2 === void 0 ? void 0 : (_template_templateBenefitsCollection_items = _template_templateBenefitsCollection2.items) === null || _template_templateBenefitsCollection_items === void 0 ? void 0 : _template_templateBenefitsCollection_items.map((templateBenefitsContainer, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $9CA5V.TemplateBenefits), {
                        templateBenefits: templateBenefitsContainer
                    }, `benefits-${index}`))
            })
        },
        {
            id: "tab3",
            title: intl.formatMessage({
                id: "ConfluenceTemplateMessages.tabs.howTo.cfind.1508",
                defaultMessage: "How to"
            }),
            hide: !((_template_howToUseThisTemplateCollection = template.howToUseThisTemplateCollection) === null || _template_howToUseThisTemplateCollection === void 0 ? void 0 : _template_howToUseThisTemplateCollection.items) || ((_template_howToUseThisTemplateCollection1 = template.howToUseThisTemplateCollection) === null || _template_howToUseThisTemplateCollection1 === void 0 ? void 0 : _template_howToUseThisTemplateCollection1.items.length) === 0,
            component: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                children: (_template_howToUseThisTemplateCollection2 = template.howToUseThisTemplateCollection) === null || _template_howToUseThisTemplateCollection2 === void 0 ? void 0 : (_template_howToUseThisTemplateCollection_items = _template_howToUseThisTemplateCollection2.items) === null || _template_howToUseThisTemplateCollection_items === void 0 ? void 0 : _template_howToUseThisTemplateCollection_items.map((templateGuide, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cdeeW.TemplateGuide), {
                        templateGuide: templateGuide
                    }, `how2use-${index}`))
            })
        },
        {
            id: "tab4",
            title: intl.formatMessage({
                id: "ConfluenceTemplateMessages.tabs.whyConfluence.cfind.1508",
                defaultMessage: "Why Confluence?"
            }),
            // temporary content for demoing... will be replaced with content from template object
            hide: !((_template_templateProductRationaleCollection = template.templateProductRationaleCollection) === null || _template_templateProductRationaleCollection === void 0 ? void 0 : _template_templateProductRationaleCollection.items),
            component: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                className: (0, $esG4f.default)([
                    "_1pfh8vuz"
                ]),
                children: (_template_templateProductRationaleCollection1 = template.templateProductRationaleCollection) === null || _template_templateProductRationaleCollection1 === void 0 ? void 0 : (_template_templateProductRationaleCollection_items = _template_templateProductRationaleCollection1.items) === null || _template_templateProductRationaleCollection_items === void 0 ? void 0 : _template_templateProductRationaleCollection_items.map((rationale, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                                ]),
                                children: rationale === null || rationale === void 0 ? void 0 : rationale.rationaleTitle
                            }),
                            (rationale === null || rationale === void 0 ? void 0 : rationale.templateProductRationaleDescription) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                                innerHTML: (0, $cyfPT.richTextToHTML)(rationale === null || rationale === void 0 ? void 0 : rationale.templateProductRationaleDescription.json)
                            })
                        ]
                    }, `rationale-${index}`))
            })
        }
    ];
    const renderTabbedSection = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4Tabs), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _e8gh1h6o"
                    ]),
                    children: tabs.filter((tab)=>!tab.hide).map((tab)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                            title: tab.title,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($6c189e34a93e2bd8$var$TabHeading, {
                                title: tab.title
                            })
                        }, tab.id))
                }),
                tabs.filter((tab)=>!tab.hide).map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                        keepInDom: true,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                            children: tab.component
                        })
                    }, index))
            ]
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        "data-testid": "template-tabbed-section",
        className: (0, $esG4f.default)([
            "_syaz1tj6 _1q51vbgk _1bsb1osq _1e0c1txw _2lx21bp4 _1o8315zi _98bk15zi _1rfm1osq"
        ]),
        style: {
            "--_1tgiy09": (0, $43MIc.default)((0, $cRwVc.default)("color.extended.blue900"))
        },
        children: renderTabbedSection()
    });
};

});
parcelRegister("9CA5V", function(module, exports) {

$parcel$export(module.exports, "TemplateBenefits", function () { return $cfb328503605d733$export$c51d82a2312a377b; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $cyfPT = parcelRequire("cyfPT");

var $A9zZc = parcelRequire("A9zZc");
var $cfb328503605d733$var$_templateBenefitsContentfulRelayFragment;
const $cfb328503605d733$var$tabbedSectionStyle = null;
const $cfb328503605d733$var$stepContainerStyle = null;
const $cfb328503605d733$var$tabbedSectionHeading = null;
const $cfb328503605d733$var$stepHeading = null;
const $cfb328503605d733$var$stepContentWrapper = null;
const $cfb328503605d733$var$TemplateBenefitsStep = ({ templateBenefitNameExternal: templateBenefitNameExternal, shortDescription: shortDescription })=>{
    const name = templateBenefitNameExternal;
    const description = (shortDescription === null || shortDescription === void 0 ? void 0 : shortDescription.json) ? (0, $cyfPT.richTextToHTML)(shortDescription.json) : "";
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _85i51wto _6rth1wto _179r87ef _zulpviql _1sag1bp4 _qw09glyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _zulpviql _11yr1k8s"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                    className: (0, $esG4f.default)([
                        "_1wyb1k8s _vwz4viql _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqs1k92 _1bys1k8s"
                    ]),
                    children: name
                }),
                description && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                    innerHTML: description
                })
            ]
        })
    });
};

const $cfb328503605d733$var$TemplateBenefitsRelayFragment = $cfb328503605d733$var$_templateBenefitsContentfulRelayFragment !== void 0 ? $cfb328503605d733$var$_templateBenefitsContentfulRelayFragment : ($cfb328503605d733$var$_templateBenefitsContentfulRelayFragment = (parcelRequire("itWmQ")), $cfb328503605d733$var$_templateBenefitsContentfulRelayFragment.hash && $cfb328503605d733$var$_templateBenefitsContentfulRelayFragment.hash !== "0aed3146fda17479886541e7fa74c49c" && console.error("The definition of 'templateBenefitsContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $cfb328503605d733$var$_templateBenefitsContentfulRelayFragment);
const $cfb328503605d733$export$c51d82a2312a377b = ({ templateBenefits: templateBenefits })=>{
    var _data_templateBenefitContainerCollection;
    const data = (0, $hOqV7.useFragment)($cfb328503605d733$var$TemplateBenefitsRelayFragment, templateBenefits);
    var _data_templateBenefitContainerCollection_items;
    const benefits = (_data_templateBenefitContainerCollection_items = (_data_templateBenefitContainerCollection = data.templateBenefitContainerCollection) === null || _data_templateBenefitContainerCollection === void 0 ? void 0 : _data_templateBenefitContainerCollection.items) !== null && _data_templateBenefitContainerCollection_items !== void 0 ? _data_templateBenefitContainerCollection_items : [];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1pfh8vuz _ahbq1wug _12l21wug _mnhn1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                ]),
                children: data.benefitsTitle
            }),
            benefits.map((benefitDetail, index)=>benefitDetail && /*#__PURE__*/ (0, $loA2J.jsx)($cfb328503605d733$var$TemplateBenefitsStep, (0, $7Knp0._)({}, benefitDetail), `benefit-${index}`))
        ]
    });
};

});
parcelRegister("itWmQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b6b6d8f61d8b9b4b$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<d0d97a268f36e5b06bacc8737d58fa3a>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b6b6d8f61d8b9b4b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateBenefitsContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "benefitsTitle",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "TemplateBenefitContainerTemplateBenefitContainerCollection",
            "kind": "LinkedField",
            "name": "templateBenefitContainerCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TemplateBenefit",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "templateBenefitNameExternal",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateBenefitShortDescription",
                            "kind": "LinkedField",
                            "name": "shortDescription",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "json",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "TemplateBenefitContainer",
    "abstractKey": null
};
$b6b6d8f61d8b9b4b$var$node.hash = "0aed3146fda17479886541e7fa74c49c";
var $b6b6d8f61d8b9b4b$export$2e2bcd8739ae039 = $b6b6d8f61d8b9b4b$var$node;

});


parcelRegister("cdeeW", function(module, exports) {

$parcel$export(module.exports, "TemplateGuide", function () { return $adafd73b4e5f143a$export$a0154bb39f3a2a91; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $cyfPT = parcelRequire("cyfPT");

var $A9zZc = parcelRequire("A9zZc");

var $lHB9W = parcelRequire("lHB9W");
var $adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment;
const $adafd73b4e5f143a$var$stepContainerStyle = null;
const $adafd73b4e5f143a$var$guideSectionHeading = null;
const $adafd73b4e5f143a$var$stepHeading = null;
const $adafd73b4e5f143a$var$stepContentWrapper = null;
const $adafd73b4e5f143a$var$stepImageWrapper = null;
const $adafd73b4e5f143a$var$stepImageStyle = null;
const $adafd73b4e5f143a$var$TemplateDetailStep = ({ step: step })=>{
    var _step_stepAsset;
    var _step_stepNameExternal;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _85i51wto _6rth1wto _179r87ef _zulpviql _1sag1bp4 _qw09glyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _zulpviql _11yr1k8s"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_1wyb1k8s _vwz4viql _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqs1k92 _1bys1k8s"
                        ]),
                        children: step === null || step === void 0 ? void 0 : step.stepNameExternal
                    }),
                    (step === null || step === void 0 ? void 0 : step.stepDescription) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                        innerHTML: (0, $cyfPT.richTextToHTML)(step === null || step === void 0 ? void 0 : step.stepDescription.json)
                    })
                ]
            }),
            (step === null || step === void 0 ? void 0 : step.stepAsset) && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_16jlidpf _1o9zidpf _69fu1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                    src: ((_step_stepAsset = step.stepAsset) === null || _step_stepAsset === void 0 ? void 0 : _step_stepAsset.url) || "",
                    alt: (_step_stepNameExternal = step.stepNameExternal) !== null && _step_stepNameExternal !== void 0 ? _step_stepNameExternal : "",
                    className: (0, $esG4f.default)([
                        "_p12fsb0t _i0i01yk2 _mnhno812"
                    ])
                })
            })
        ]
    });
};

const $adafd73b4e5f143a$var$TemplateGuideRelayFragment = $adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment !== void 0 ? $adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment : ($adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment = (parcelRequire("d3bcC")), $adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment.hash && $adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment.hash !== "0e73fcc9a5b16d949c71909fe7de9c38" && console.error("The definition of 'templateGuideContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment);
const $adafd73b4e5f143a$export$a0154bb39f3a2a91 = ({ templateGuide: templateGuide })=>{
    var _data_templateStepsCollection;
    const data = (0, $hOqV7.useFragment)($adafd73b4e5f143a$var$TemplateGuideRelayFragment, templateGuide);
    const name = data.templateGuideNameExternal;
    const steps = (_data_templateStepsCollection = data.templateStepsCollection) === null || _data_templateStepsCollection === void 0 ? void 0 : _data_templateStepsCollection.items;
    const guideName = (0, $lHB9W.expectContent)(name, "Template guide name not found");
    const guideSectionStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1pfh8vuz _ahbq1wug _12l21wug _49yfidpf _hfixidpf _mnhn1osq _i0i0z8o0"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                ]),
                children: guideName
            }),
            steps === null || steps === void 0 ? void 0 : steps.map((step, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($adafd73b4e5f143a$var$TemplateDetailStep, {
                    step: step
                }, `step-${index}`))
        ]
    });
};

});
parcelRegister("d3bcC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f635c7499ac0a9ad$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<ab1c2c9ad603ce07e3a7949a8d210f73>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f635c7499ac0a9ad$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateGuideContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateGuideNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "TemplateGuideTemplateStepsCollection",
            "kind": "LinkedField",
            "name": "templateStepsCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TemplateUseStep",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stepNameExternal",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateUseStepStepDescription",
                            "kind": "LinkedField",
                            "name": "stepDescription",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "json",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "stepAsset",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "TemplateGuide",
    "abstractKey": null
};
$f635c7499ac0a9ad$var$node.hash = "0e73fcc9a5b16d949c71909fe7de9c38";
var $f635c7499ac0a9ad$export$2e2bcd8739ae039 = $f635c7499ac0a9ad$var$node;

});


parcelRegister("1RYwV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $343034f9c1ace3bb$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<00ee0f9e76c76376e5aedb6c4b48c533>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $343034f9c1ace3bb$var$node = function() {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "json",
            "storageKey": null
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "templateTabbedSectionContentfulRelayFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateOverviewCollection",
                "kind": "LinkedField",
                "name": "templateOverviewCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateOverview",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "overviewTitle",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "TemplateOverviewOverviewDescription",
                                "kind": "LinkedField",
                                "name": "overviewDescription",
                                "plural": false,
                                "selections": v0 /*: any*/ ,
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateBenefitsCollection",
                "kind": "LinkedField",
                "name": "templateBenefitsCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateBenefitContainer",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "templateBenefitsContentfulRelayFragment"
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateHowToUseThisTemplateCollection",
                "kind": "LinkedField",
                "name": "howToUseThisTemplateCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateGuide",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "templateGuideContentfulRelayFragment"
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateProductRationaleCollection",
                "kind": "LinkedField",
                "name": "templateProductRationaleCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateProductRationale",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rationaleTitle",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "TemplateProductRationaleTemplateProductRationaleDescription",
                                "kind": "LinkedField",
                                "name": "templateProductRationaleDescription",
                                "plural": false,
                                "selections": v0 /*: any*/ ,
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "ProductTemplate",
        "abstractKey": null
    };
}();
$343034f9c1ace3bb$var$node.hash = "9e2878135e8f926d46ac10f3a93bce05";
var $343034f9c1ace3bb$export$2e2bcd8739ae039 = $343034f9c1ace3bb$var$node;

});


parcelRegister("aElNK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ba5e3f42782b7174$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<035d64212bd2516ee41d4e4e51b50c04>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ba5e3f42782b7174$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateDetailsSectionContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pluginModuleKey",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplateTemplateTypeCollection",
            "kind": "LinkedField",
            "name": "templateTypeCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaxonomyTemplateType",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sys",
                            "kind": "LinkedField",
                            "name": "sys",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "templateTypeNameExternal",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templatePreviewContentfulRelayFragment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templateDescriptionContentfulRelayFragment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templateTabbedSectionContentfulRelayFragment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templateRelatedTemplatesContentfulRelayFragment"
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$ba5e3f42782b7174$var$node.hash = "e8b8a2fa5d16d077e413ac61f87dea66";
var $ba5e3f42782b7174$export$2e2bcd8739ae039 = $ba5e3f42782b7174$var$node;

});


parcelRegister("fWQ89", function(module, exports) {

$parcel$export(module.exports, "TemplateHeaderSection", function () { return $b0bf473b1e1f8957$export$8e42656558633420; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $1XyNv = parcelRequire("1XyNv");

var $95kuv = parcelRequire("95kuv");

var $9hcZe = parcelRequire("9hcZe");
var $b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment;
const $b0bf473b1e1f8957$var$headerSectionStyles = null;
const $b0bf473b1e1f8957$var$titleStyles = null;
const $b0bf473b1e1f8957$var$subTitleStyles = null;

const $b0bf473b1e1f8957$var$TemplateHeaderSectionContentfulRelayFragment = $b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment !== void 0 ? $b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment : ($b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment = (parcelRequire("45dRv")), $b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment.hash && $b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment.hash !== "8f8ff649db77b91366c4318c307ecb02" && console.error("The definition of 'templateHeaderSectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment);
const $b0bf473b1e1f8957$export$8e42656558633420 = ({ template: templateRef })=>{
    const template = (0, $hOqV7.useFragment)($b0bf473b1e1f8957$var$TemplateHeaderSectionContentfulRelayFragment, templateRef);
    const { templateNameExternal: templateNameExternal, oneLinerHeadline: oneLinerHeadline, pluginModuleKey: pluginModuleKey } = template;
    const intl = (0, $f6qj2.default)();
    const templateName = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).templateTitle, {
        templateName: templateNameExternal !== null && templateNameExternal !== void 0 ? templateNameExternal : ""
    });
    const renderCtaButons = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $95kuv.TemplateCtaButtons), {
            name: templateName,
            pluginModuleKey: pluginModuleKey || ""
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        "data-testid": "TemplateHeaderSection",
        className: (0, $esG4f.default)([
            "_12ornqa1 _1r62t94y _1ezz1f7l _1e0c1txw _2lx21bp4 _85i51tcg _ag851h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_syazalr3 _ect4kipj _1wyb1ex1 _zg8l4jg8 _k48pbfng _vwz41wqb _6rth7vkz _1pfhidpf _1i4q1hna _xsmr1h6o"
                ]),
                children: templateName
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $9hcZe.TemplateAuthor), {
                template: template
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_syazalr3 _ect48q0o _1wybgktf _zg8l4jg8 _k48p1nn1 _vwz41f4h _6rthzwfg _1pfhidpf _xsmr1h6o"
                ]),
                children: oneLinerHeadline
            }),
            renderCtaButons()
        ]
    });
};

});
parcelRegister("9hcZe", function(module, exports) {

$parcel$export(module.exports, "TemplateAuthor", function () { return $11007b2bb85318fc$export$f6f32ceede8fcfff; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $hOqV7 = parcelRequire("hOqV7");

var $1XyNv = parcelRequire("1XyNv");
var $11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment;
const $11007b2bb85318fc$var$templateAuthor = null;
const $11007b2bb85318fc$var$isAuthor = (contributor)=>(contributor === null || contributor === void 0 ? void 0 : contributor.__typename) === "Author";
const $11007b2bb85318fc$var$isOrganization = (contributor)=>(contributor === null || contributor === void 0 ? void 0 : contributor.__typename) === "CompanyNameInternal";

const $11007b2bb85318fc$var$TemplateAuthorRelayFragment = $11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment !== void 0 ? $11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment : ($11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment = (parcelRequire("klGkS")), $11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment.hash && $11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment.hash !== "f1d1931be967bc795ac40098c74ecc54" && console.error("The definition of 'templateAuthorContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment);
const $11007b2bb85318fc$export$f6f32ceede8fcfff = ({ template: template })=>{
    var _author_organization;
    const { contributor: contributor } = (0, $hOqV7.useFragment)($11007b2bb85318fc$var$TemplateAuthorRelayFragment, template);
    let contributorName = $11007b2bb85318fc$var$isAuthor(contributor) && contributor.authorNameExternal || $11007b2bb85318fc$var$isOrganization(contributor) && contributor.organizationNameExternal || undefined;
    const author = $11007b2bb85318fc$var$isAuthor(contributor) ? contributor : null;
    let authorDetail = author === null || author === void 0 ? void 0 : author.jobTitle;
    if (authorDetail && (author === null || author === void 0 ? void 0 : (_author_organization = author.organization) === null || _author_organization === void 0 ? void 0 : _author_organization.organizationNameExternal)) authorDetail = `${authorDetail} @ ${author.organization.organizationNameExternal}`;
    if (authorDetail) contributorName = `${contributorName}, (${authorDetail})`;
    return contributorName && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
        className: (0, $esG4f.default)([
            "_1wyboqnp _vwz41neg _k48pbfng _syazrbzz _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1tcg _1p1dangw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $1XyNv.ConfluenceTemplateMessages).templateAuthorByLine), {
            values: {
                author: contributorName
            }
        }))
    });
};

});
parcelRegister("klGkS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $50500fafb45ab71e$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<924a1724830bde4a0d657e5e8135325a>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $50500fafb45ab71e$var$node = function() {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationNameExternal",
            "storageKey": null
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "templateAuthorContentfulRelayFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contributor",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "authorNameExternal",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "jobTitle",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompanyNameInternal",
                                "kind": "LinkedField",
                                "name": "organization",
                                "plural": false,
                                "selections": v0 /*: any*/ ,
                                "storageKey": null
                            }
                        ],
                        "type": "Author",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": v0 /*: any*/ ,
                        "type": "CompanyNameInternal",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "ProductTemplate",
        "abstractKey": null
    };
}();
$50500fafb45ab71e$var$node.hash = "f1d1931be967bc795ac40098c74ecc54";
var $50500fafb45ab71e$export$2e2bcd8739ae039 = $50500fafb45ab71e$var$node;

});


parcelRegister("45dRv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8ab38643b6fb5dc9$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<c3300acdc249c500bc3a727bd6e88894>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8ab38643b6fb5dc9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateHeaderSectionContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oneLinerHeadline",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pluginModuleKey",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templateAuthorContentfulRelayFragment"
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$8ab38643b6fb5dc9$var$node.hash = "8f8ff649db77b91366c4318c307ecb02";
var $8ab38643b6fb5dc9$export$2e2bcd8739ae039 = $8ab38643b6fb5dc9$var$node;

});


parcelRegister("8b1Ol", function(module, exports) {

$parcel$export(module.exports, "TemplateKeyFeaturesSection", function () { return $82770422dcf905f7$export$b2854e9c3155c1cd; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $l2OTr = parcelRequire("l2OTr");
var $82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment;
const $82770422dcf905f7$var$keyFeaturesStyles = null;
const $82770422dcf905f7$var$headingStyles = null;
const $82770422dcf905f7$var$featureStyles = null;
const $82770422dcf905f7$var$featureTextStyles = null;

const $82770422dcf905f7$var$TemplateKeyFeaturesSectionFragment = $82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment !== void 0 ? $82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment : ($82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment = (parcelRequire("2THDh")), $82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment.hash && $82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment.hash !== "ea58d8a7472ddea992087c51d1db8a28" && console.error("The definition of 'templateKeyFeaturesSectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment); // TODO: will get features from template
const $82770422dcf905f7$export$b2854e9c3155c1cd = ({ template: template })=>{
    var _data_keyFeaturesCollection;
    const data = (0, $hOqV7.useFragment)($82770422dcf905f7$var$TemplateKeyFeaturesSectionFragment, template);
    const keyFeatures = (data === null || data === void 0 ? void 0 : (_data_keyFeaturesCollection = data.keyFeaturesCollection) === null || _data_keyFeaturesCollection === void 0 ? void 0 : _data_keyFeaturesCollection.items) || [];
    const intl = (0, $f6qj2.default)(); // TODO: temp placeholder data for UI purposes
    const features = keyFeatures !== null && keyFeatures !== void 0 ? keyFeatures : [];
    const headingText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.keyFeatures.heading",
        defaultMessage: "KEY FEATURES"
    });
    return !!features.length && /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1q51zwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h5", {
                className: (0, $esG4f.default)([
                    "_syaz19tk _1wyboqnp _k48p1nn1 _1dyzt94y _6rthftgi"
                ]),
                children: headingText
            }),
            features.filter((feature)=>(feature === null || feature === void 0 ? void 0 : feature.featureNameExternal) != null).map((feature)=>/*#__PURE__*/ {
                var _feature_featureNameExternal;
                return (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_4cvr1h6o _syazalr3 _1e0c1txw _4t3i1ylp _1q51ftgi"
                    ]),
                    children: [
                        (0, $l2OTr.getIcon)((_feature_featureNameExternal = feature === null || feature === void 0 ? void 0 : feature.featureNameExternal) !== null && _feature_featureNameExternal !== void 0 ? _feature_featureNameExternal : ""),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_ahbqdlk8"
                            ]),
                            children: feature === null || feature === void 0 ? void 0 : feature.featureNameExternal
                        })
                    ]
                }, feature === null || feature === void 0 ? void 0 : feature.featureNameExternal);
            })
        ]
    });
};
var $82770422dcf905f7$export$2e2bcd8739ae039 = $82770422dcf905f7$export$b2854e9c3155c1cd;

});
parcelRegister("2THDh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $940b70971081fe1e$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<cdbb621ac4ef7944807ab770c230da08>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $940b70971081fe1e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateKeyFeaturesSectionContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplateKeyFeaturesCollection",
            "kind": "LinkedField",
            "name": "keyFeaturesCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaxonomyFeature",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "featureNameExternal",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$940b70971081fe1e$var$node.hash = "ea58d8a7472ddea992087c51d1db8a28";
var $940b70971081fe1e$export$2e2bcd8739ae039 = $940b70971081fe1e$var$node;

});


parcelRegister("2KyLQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9b50fb2eb2b68c3e$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<ecc6c31075605bf43e861e94c653be35>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9b50fb2eb2b68c3e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "urlSlug"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 1
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "urlSlug",
                    "variableName": "urlSlug"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "templateNameExternal",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pluginModuleKey",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v6 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationNameExternal",
            "storageKey": null
        }
    ], v7 = {
        "alias": null,
        "args": null,
        "concreteType": "CompanyNameInternal",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": null
    }, v8 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "CompanyNameInternal",
        "abstractKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "concreteType": "ProductTemplateTemplateTypeCollection",
        "kind": "LinkedField",
        "name": "templateTypeCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyTemplateType",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "templateTypeNameExternal",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlSlug",
        "storageKey": null
    }, v11 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        }
    ], v12 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "json",
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "confluenceTemplateDetailsContentfulRelayPageQuery",
            "selections": [
                {
                    "alias": "templates",
                    "args": v1 /*: any*/ ,
                    "concreteType": "ProductTemplateCollection",
                    "kind": "LinkedField",
                    "name": "productTemplateCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductTemplate",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "templateHeaderSectionContentfulRelayFragment"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "templateKeyFeaturesSectionContentfulRelayFragment"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "templateCategorySectionContentfulRelayFragment"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "templateDetailsSectionContentfulRelayFragment"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "confluenceTemplateDetailsContentfulRelayPageQuery",
            "selections": [
                {
                    "alias": "templates",
                    "args": v1 /*: any*/ ,
                    "concreteType": "ProductTemplateCollection",
                    "kind": "LinkedField",
                    "name": "productTemplateCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductTemplate",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "oneLinerHeadline",
                                    "storageKey": null
                                },
                                v4 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "contributor",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "authorNameExternal",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "jobTitle",
                                                    "storageKey": null
                                                },
                                                v7 /*: any*/ 
                                            ],
                                            "type": "Author",
                                            "abstractKey": null
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateKeyFeaturesCollection",
                                    "kind": "LinkedField",
                                    "name": "keyFeaturesCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaxonomyFeature",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "featureNameExternal",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                v9 /*: any*/ ,
                                {
                                    "alias": "categories",
                                    "args": null,
                                    "concreteType": "ProductTemplateCategoryCollection",
                                    "kind": "LinkedField",
                                    "name": "categoryCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaxonomyTemplateCategory",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "categoryNameExternal",
                                                    "storageKey": null
                                                },
                                                v10 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": "templatePreviews",
                                    "args": null,
                                    "concreteType": "AssetCollection",
                                    "kind": "LinkedField",
                                    "name": "templatePreviewCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Asset",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": v11 /*: any*/ ,
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateAboutThisTemplate",
                                    "kind": "LinkedField",
                                    "name": "aboutThisTemplate",
                                    "plural": false,
                                    "selections": v12 /*: any*/ ,
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateTemplateOverviewCollection",
                                    "kind": "LinkedField",
                                    "name": "templateOverviewCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TemplateOverview",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "overviewTitle",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TemplateOverviewOverviewDescription",
                                                    "kind": "LinkedField",
                                                    "name": "overviewDescription",
                                                    "plural": false,
                                                    "selections": v12 /*: any*/ ,
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateTemplateBenefitsCollection",
                                    "kind": "LinkedField",
                                    "name": "templateBenefitsCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TemplateBenefitContainer",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "benefitsTitle",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TemplateBenefitContainerTemplateBenefitContainerCollection",
                                                    "kind": "LinkedField",
                                                    "name": "templateBenefitContainerCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TemplateBenefit",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "templateBenefitNameExternal",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TemplateBenefitShortDescription",
                                                                    "kind": "LinkedField",
                                                                    "name": "shortDescription",
                                                                    "plural": false,
                                                                    "selections": v12 /*: any*/ ,
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateHowToUseThisTemplateCollection",
                                    "kind": "LinkedField",
                                    "name": "howToUseThisTemplateCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TemplateGuide",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "templateGuideNameExternal",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TemplateGuideTemplateStepsCollection",
                                                    "kind": "LinkedField",
                                                    "name": "templateStepsCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TemplateUseStep",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "stepNameExternal",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TemplateUseStepStepDescription",
                                                                    "kind": "LinkedField",
                                                                    "name": "stepDescription",
                                                                    "plural": false,
                                                                    "selections": v12 /*: any*/ ,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Asset",
                                                                    "kind": "LinkedField",
                                                                    "name": "stepAsset",
                                                                    "plural": false,
                                                                    "selections": v11 /*: any*/ ,
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateTemplateProductRationaleCollection",
                                    "kind": "LinkedField",
                                    "name": "templateProductRationaleCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TemplateProductRationale",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "rationaleTitle",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TemplateProductRationaleTemplateProductRationaleDescription",
                                                    "kind": "LinkedField",
                                                    "name": "templateProductRationaleDescription",
                                                    "plural": false,
                                                    "selections": v12 /*: any*/ ,
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateRelatedTemplatesCollection",
                                    "kind": "LinkedField",
                                    "name": "relatedTemplatesCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductTemplate",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "previewBlurb",
                                                    "storageKey": null
                                                },
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "contributor",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ 
                                                            ],
                                                            "type": "Author",
                                                            "abstractKey": null
                                                        },
                                                        v8 /*: any*/ 
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "1e56998e7009ce85b94c239b1b20a58d",
            "id": null,
            "metadata": {},
            "name": "confluenceTemplateDetailsContentfulRelayPageQuery",
            "operationKind": "query",
            "text": "query confluenceTemplateDetailsContentfulRelayPageQuery(\n  $locale: String\n  $urlSlug: String\n) {\n  templates: productTemplateCollection(limit: 1, locale: $locale, where: {urlSlug: $urlSlug}) {\n    items {\n      sys {\n        id\n      }\n      ...templateHeaderSectionContentfulRelayFragment\n      ...templateKeyFeaturesSectionContentfulRelayFragment\n      ...templateCategorySectionContentfulRelayFragment\n      ...templateDetailsSectionContentfulRelayFragment\n    }\n  }\n}\n\nfragment templateAuthorContentfulRelayFragment on ProductTemplate {\n  contributor {\n    __typename\n    ... on Author {\n      authorNameExternal\n      jobTitle\n      organization {\n        organizationNameExternal\n      }\n    }\n    ... on CompanyNameInternal {\n      organizationNameExternal\n    }\n  }\n}\n\nfragment templateBenefitsContentfulRelayFragment on TemplateBenefitContainer {\n  benefitsTitle\n  templateBenefitContainerCollection {\n    items {\n      templateBenefitNameExternal\n      shortDescription {\n        json\n      }\n    }\n  }\n}\n\nfragment templateCardContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  templateNameExternal\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  contributor {\n    __typename\n    ... on Author {\n      organization {\n        organizationNameExternal\n      }\n    }\n    ... on CompanyNameInternal {\n      organizationNameExternal\n    }\n  }\n}\n\nfragment templateCategorySectionContentfulRelayFragment on ProductTemplate {\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  categories: categoryCollection {\n    items {\n      sys {\n        id\n      }\n      categoryNameExternal\n      urlSlug\n    }\n  }\n}\n\nfragment templateDescriptionContentfulRelayFragment on ProductTemplate {\n  aboutThisTemplate {\n    json\n  }\n}\n\nfragment templateDetailsSectionContentfulRelayFragment on ProductTemplate {\n  templateNameExternal\n  pluginModuleKey\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  ...templatePreviewContentfulRelayFragment\n  ...templateDescriptionContentfulRelayFragment\n  ...templateTabbedSectionContentfulRelayFragment\n  ...templateRelatedTemplatesContentfulRelayFragment\n}\n\nfragment templateGuideContentfulRelayFragment on TemplateGuide {\n  templateGuideNameExternal\n  templateStepsCollection {\n    items {\n      stepNameExternal\n      stepDescription {\n        json\n      }\n      stepAsset {\n        url\n      }\n    }\n  }\n}\n\nfragment templateHeaderSectionContentfulRelayFragment on ProductTemplate {\n  templateNameExternal\n  oneLinerHeadline\n  pluginModuleKey\n  ...templateAuthorContentfulRelayFragment\n}\n\nfragment templateKeyFeaturesSectionContentfulRelayFragment on ProductTemplate {\n  keyFeaturesCollection {\n    items {\n      featureNameExternal\n    }\n  }\n}\n\nfragment templatePreviewContentfulRelayFragment on ProductTemplate {\n  templateNameExternal\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n    }\n  }\n  templatePreviews: templatePreviewCollection {\n    items {\n      url\n    }\n  }\n}\n\nfragment templateRelatedTemplatesContentfulRelayFragment on ProductTemplate {\n  relatedTemplatesCollection {\n    items {\n      sys {\n        id\n      }\n      ...templateCardContentfulRelayFragment\n    }\n  }\n}\n\nfragment templateTabbedSectionContentfulRelayFragment on ProductTemplate {\n  templateOverviewCollection {\n    items {\n      overviewTitle\n      overviewDescription {\n        json\n      }\n    }\n  }\n  templateBenefitsCollection {\n    items {\n      ...templateBenefitsContentfulRelayFragment\n    }\n  }\n  howToUseThisTemplateCollection {\n    items {\n      ...templateGuideContentfulRelayFragment\n    }\n  }\n  templateProductRationaleCollection {\n    items {\n      rationaleTitle\n      templateProductRationaleDescription {\n        json\n      }\n    }\n  }\n}\n"
        }
    };
}();
$9b50fb2eb2b68c3e$var$node.hash = "58f05b29349913b5b21e570429855a37";
var $9b50fb2eb2b68c3e$export$2e2bcd8739ae039 = $9b50fb2eb2b68c3e$var$node;

});



parcelRegister("200NX", function(module, exports) {

$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $52ea49f8e16543b5$export$7b31a9938ec3ba75; });
const $52ea49f8e16543b5$export$7b31a9938ec3ba75 = "contentful";

});

parcelRegister("2A2ZL", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $f29b64522dc0a459$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $hOqV7 = parcelRequire("hOqV7");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $200NX = parcelRequire("200NX");

var $kNCWT = parcelRequire("kNCWT");

var $j0nzO = parcelRequire("j0nzO");

var $14zFQ = parcelRequire("14zFQ");

var $dJ4mM = parcelRequire("dJ4mM");

var $1FD73 = parcelRequire("1FD73");

var $6wlNh = parcelRequire("6wlNh");

var $k2OeR = parcelRequire("k2OeR");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-225d09f96f";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $f29b64522dc0a459$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(document.cookie, locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const isStatic = typeof window !== "undefined" && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $200NX.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $kNCWT.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $1FD73.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $hOqV7.loadQuery)(relayEnvironment, query, queryVars);
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
                locale: locale,
                messages: window.SSR_languagePack,
                cookies: document.cookie,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hOqV7.RelayEnvironmentProvider), {
                    environment: relayEnvironment,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ4mM.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        pureClientMode: true,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        subAnchor: window.subAnchor,
                        auxiaResponse: window.auxiaResponse,
                        queryRef: queryRef,
                        transactionAccounts: window.transactionAccounts,
                        userAgent: userAgent,
                        children: Component
                    })
                })
            }));
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), /*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hOqV7.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $14zFQ.Layout), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    countryCode: window.countryCode,
                    mlTemplateIds: window.mlTemplateIds,
                    keyword: window.keyword,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    queryRef: queryRef,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    children: Component
                })
            })
        }), {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("1FD73", function(module, exports) {

$parcel$export(module.exports, "initRelayEnvironment", function () { return $7d9774703a666878$export$1456be3de97c862f; });

var $4PJsz = parcelRequire("4PJsz");
(0, $4PJsz.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $7d9774703a666878$var$GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
function $7d9774703a666878$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride !== null && baseUrlOverride !== void 0 ? baseUrlOverride : $7d9774703a666878$var$GATEWAY_URL;
    let headers = {
        "Content-Type": "application/json"
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: "POST",
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? "same-origin" : "include",
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $4PJsz.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            // @ts-ignore
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, "10_100_500_1000_2000_3000_5000_10000_30000", duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get("x-cache"),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $4PJsz.Network).create(fetchResponse);
    const store = new (0, $4PJsz.Store)(new (0, $4PJsz.RecordSource)(initialRecords));
    return new (0, $4PJsz.Environment)({
        network: network,
        store: store
    });
}
let $7d9774703a666878$var$clientSideRelayEnvironment;
function $7d9774703a666878$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $7d9774703a666878$var$clientSideRelayEnvironment !== null && $7d9774703a666878$var$clientSideRelayEnvironment !== void 0 ? $7d9774703a666878$var$clientSideRelayEnvironment : $7d9774703a666878$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === "undefined") return environment;
    if (!$7d9774703a666878$var$clientSideRelayEnvironment) $7d9774703a666878$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $4PJsz.RecordSource)(initialRecords));
    return $7d9774703a666878$var$clientSideRelayEnvironment;
}

});


parcelRegister("iHyWi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9d7585a20730163$var$_react = $d9d7585a20730163$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d9d7585a20730163$var$_statusSuccess = $d9d7585a20730163$var$_interopRequireDefault((parcelRequire("hxhx5")));
function $d9d7585a20730163$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d9d7585a20730163$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $d9d7585a20730163$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d9d7585a20730163$var$_statusSuccess.default
    }));
$d9d7585a20730163$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $d9d7585a20730163$var$_default = module.exports.default = $d9d7585a20730163$var$CheckCircleIcon;

});
parcelRegister("hxhx5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8cc756abdbbefcea85e2842ee2eda39e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc431e5821625fac$var$_react = $cc431e5821625fac$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $cc431e5821625fac$var$_baseNew = $cc431e5821625fac$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $cc431e5821625fac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc431e5821625fac$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $cc431e5821625fac$var$_react.default.createElement($cc431e5821625fac$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$cc431e5821625fac$var$StatusSuccessIcon.displayName = "StatusSuccessIcon";
var $cc431e5821625fac$var$_default = module.exports.default = $cc431e5821625fac$var$StatusSuccessIcon;

});


parcelRegister("ixaDK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7e38ffb7694e997$var$_react = $d7e38ffb7694e997$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d7e38ffb7694e997$var$_refresh = $d7e38ffb7694e997$var$_interopRequireDefault((parcelRequire("5sfxx")));
function $d7e38ffb7694e997$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d7e38ffb7694e997$var$RefreshIcon = (props)=>/*#__PURE__*/ $d7e38ffb7694e997$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $d7e38ffb7694e997$var$_refresh.default
    }));
$d7e38ffb7694e997$var$RefreshIcon.displayName = "RefreshIcon";
var $d7e38ffb7694e997$var$_default = module.exports.default = $d7e38ffb7694e997$var$RefreshIcon;

});
parcelRegister("5sfxx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f8b9f2e6d41a4e8$var$_react = $3f8b9f2e6d41a4e8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3f8b9f2e6d41a4e8$var$_baseNew = $3f8b9f2e6d41a4e8$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $3f8b9f2e6d41a4e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f8b9f2e6d41a4e8$var$RefreshIcon = (props)=>/*#__PURE__*/ $3f8b9f2e6d41a4e8$var$_react.default.createElement($3f8b9f2e6d41a4e8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$3f8b9f2e6d41a4e8$var$RefreshIcon.displayName = "RefreshIcon";
var $3f8b9f2e6d41a4e8$var$_default = module.exports.default = $3f8b9f2e6d41a4e8$var$RefreshIcon;

});


parcelRegister("ctYD4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9167392384132023$var$_react = $9167392384132023$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9167392384132023$var$_baseNew = $9167392384132023$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $9167392384132023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9167392384132023$var$CommentIcon = (props)=>/*#__PURE__*/ $9167392384132023$var$_react.default.createElement($9167392384132023$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$9167392384132023$var$CommentIcon.displayName = "CommentIcon";
var $9167392384132023$var$_default = module.exports.default = $9167392384132023$var$CommentIcon;

});

parcelRegister("ft8Zd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b43088f9384ecc2c$var$_react = $b43088f9384ecc2c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b43088f9384ecc2c$var$_baseNew = $b43088f9384ecc2c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b43088f9384ecc2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b43088f9384ecc2c$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $b43088f9384ecc2c$var$_react.default.createElement($b43088f9384ecc2c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$b43088f9384ecc2c$var$PeopleGroupIcon.displayName = "PeopleGroupIcon";
var $b43088f9384ecc2c$var$_default = module.exports.default = $b43088f9384ecc2c$var$PeopleGroupIcon;

});

parcelRegister("itghZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d72792188beaf418$var$_react = $d72792188beaf418$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d72792188beaf418$var$_peopleGroup = $d72792188beaf418$var$_interopRequireDefault((parcelRequire("ft8Zd")));
function $d72792188beaf418$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d72792188beaf418$var$PeopleIcon = (props)=>/*#__PURE__*/ $d72792188beaf418$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $d72792188beaf418$var$_peopleGroup.default
    }));
$d72792188beaf418$var$PeopleIcon.displayName = "PeopleIcon";
var $d72792188beaf418$var$_default = module.exports.default = $d72792188beaf418$var$PeopleIcon;

});

parcelRegister("9kkWb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::654979ffcf55141d2c08f198a843721e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ca6390960ed258c$var$_react = $6ca6390960ed258c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6ca6390960ed258c$var$_baseNew = $6ca6390960ed258c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $6ca6390960ed258c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ca6390960ed258c$var$SettingsIcon = (props)=>/*#__PURE__*/ $6ca6390960ed258c$var$_react.default.createElement($6ca6390960ed258c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$6ca6390960ed258c$var$SettingsIcon.displayName = "SettingsIcon";
var $6ca6390960ed258c$var$_default = module.exports.default = $6ca6390960ed258c$var$SettingsIcon;

});

parcelRegister("cgxwH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ee0fc5254d5e6d3$var$_react = $8ee0fc5254d5e6d3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $8ee0fc5254d5e6d3$var$_settings = $8ee0fc5254d5e6d3$var$_interopRequireDefault((parcelRequire("9kkWb")));
function $8ee0fc5254d5e6d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8ee0fc5254d5e6d3$var$SettingsIcon = (props)=>/*#__PURE__*/ $8ee0fc5254d5e6d3$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $8ee0fc5254d5e6d3$var$_settings.default
    }));
$8ee0fc5254d5e6d3$var$SettingsIcon.displayName = "SettingsIcon";
var $8ee0fc5254d5e6d3$var$_default = module.exports.default = $8ee0fc5254d5e6d3$var$SettingsIcon;

});

parcelRegister("7fq8b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $546e343250e73767$var$_react = $546e343250e73767$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $546e343250e73767$var$_baseNew = $546e343250e73767$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $546e343250e73767$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $546e343250e73767$var$BacklogIcon = (props)=>/*#__PURE__*/ $546e343250e73767$var$_react.default.createElement($546e343250e73767$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$546e343250e73767$var$BacklogIcon.displayName = "BacklogIcon";
var $546e343250e73767$var$_default = module.exports.default = $546e343250e73767$var$BacklogIcon;

});

parcelRegister("20L2t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84a07eff465bcaaea8db49f0fc7877da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $177011d2e77c7e3d$var$_react = $177011d2e77c7e3d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $177011d2e77c7e3d$var$_baseNew = $177011d2e77c7e3d$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $177011d2e77c7e3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $177011d2e77c7e3d$var$DepartmentIcon = (props)=>/*#__PURE__*/ $177011d2e77c7e3d$var$_react.default.createElement($177011d2e77c7e3d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$177011d2e77c7e3d$var$DepartmentIcon.displayName = "DepartmentIcon";
var $177011d2e77c7e3d$var$_default = module.exports.default = $177011d2e77c7e3d$var$DepartmentIcon;

});

parcelRegister("aRydc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e896462d00fee46$var$_react = $7e896462d00fee46$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7e896462d00fee46$var$_baseNew = $7e896462d00fee46$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $7e896462d00fee46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e896462d00fee46$var$EditIcon = (props)=>/*#__PURE__*/ $7e896462d00fee46$var$_react.default.createElement($7e896462d00fee46$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$7e896462d00fee46$var$EditIcon.displayName = "EditIcon";
var $7e896462d00fee46$var$_default = module.exports.default = $7e896462d00fee46$var$EditIcon;

});

parcelRegister("g0xEi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba76bf61c8eefd7a$var$_react = $ba76bf61c8eefd7a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ba76bf61c8eefd7a$var$_baseNew = $ba76bf61c8eefd7a$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ba76bf61c8eefd7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba76bf61c8eefd7a$var$PersonAddIcon = (props)=>/*#__PURE__*/ $ba76bf61c8eefd7a$var$_react.default.createElement($ba76bf61c8eefd7a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$ba76bf61c8eefd7a$var$PersonAddIcon.displayName = "PersonAddIcon";
var $ba76bf61c8eefd7a$var$_default = module.exports.default = $ba76bf61c8eefd7a$var$PersonAddIcon;

});

parcelRegister("eH5ui", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab29569377c90e7c$var$_react = $ab29569377c90e7c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ab29569377c90e7c$var$_baseNew = $ab29569377c90e7c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ab29569377c90e7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab29569377c90e7c$var$TeamsIcon = (props)=>/*#__PURE__*/ $ab29569377c90e7c$var$_react.default.createElement($ab29569377c90e7c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$ab29569377c90e7c$var$TeamsIcon.displayName = "TeamsIcon";
var $ab29569377c90e7c$var$_default = module.exports.default = $ab29569377c90e7c$var$TeamsIcon;

});

parcelRegister("lPup9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe45f21b5f8e4d30$var$_react = $fe45f21b5f8e4d30$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fe45f21b5f8e4d30$var$_baseNew = $fe45f21b5f8e4d30$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $fe45f21b5f8e4d30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe45f21b5f8e4d30$var$BoardIcon = (props)=>/*#__PURE__*/ $fe45f21b5f8e4d30$var$_react.default.createElement($fe45f21b5f8e4d30$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$fe45f21b5f8e4d30$var$BoardIcon.displayName = "BoardIcon";
var $fe45f21b5f8e4d30$var$_default = module.exports.default = $fe45f21b5f8e4d30$var$BoardIcon;

});

parcelRegister("kqqsh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83cc862a6ce0fb1f7d8883d625af8c63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edeac1c64e4915f3$var$_react = $edeac1c64e4915f3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $edeac1c64e4915f3$var$_baseNew = $edeac1c64e4915f3$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $edeac1c64e4915f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edeac1c64e4915f3$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $edeac1c64e4915f3$var$_react.default.createElement($edeac1c64e4915f3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$edeac1c64e4915f3$var$BookWithBookmarkIcon.displayName = "BookWithBookmarkIcon";
var $edeac1c64e4915f3$var$_default = module.exports.default = $edeac1c64e4915f3$var$BookWithBookmarkIcon;

});

parcelRegister("jcATf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dfabc0eb4536ae78$var$_react = $dfabc0eb4536ae78$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $dfabc0eb4536ae78$var$_baseNew = $dfabc0eb4536ae78$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $dfabc0eb4536ae78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dfabc0eb4536ae78$var$DecisionIcon = (props)=>/*#__PURE__*/ $dfabc0eb4536ae78$var$_react.default.createElement($dfabc0eb4536ae78$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$dfabc0eb4536ae78$var$DecisionIcon.displayName = "DecisionIcon";
var $dfabc0eb4536ae78$var$_default = module.exports.default = $dfabc0eb4536ae78$var$DecisionIcon;

});

parcelRegister("wQpQg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b192fbc7db5453924997563ea93d01df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $062ba5f60682b26e$var$_react = $062ba5f60682b26e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $062ba5f60682b26e$var$_baseNew = $062ba5f60682b26e$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $062ba5f60682b26e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Files".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: documents, files. Do not use to represent pages — use the dedicated 'Pages' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $062ba5f60682b26e$var$FilesIcon = (props)=>/*#__PURE__*/ $062ba5f60682b26e$var$_react.default.createElement($062ba5f60682b26e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 11a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4.25c0-.52-.208-1.02-.578-1.385L9.072.543A1.88 1.88 0 0 0 7.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h3v2.75c0 .414.336.75.75.75h2.75v6a.5.5 0 0 1-.5.5zm5.93-8H8.5V2.087z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7 16h4.75A3.25 3.25 0 0 0 15 12.75V5h-1.5v7.75a1.75 1.75 0 0 1-1.75 1.75H7z" clip-rule="evenodd"/>`
    }, props));
$062ba5f60682b26e$var$FilesIcon.displayName = "FilesIcon";
var $062ba5f60682b26e$var$_default = module.exports.default = $062ba5f60682b26e$var$FilesIcon;

});

parcelRegister("cm6I6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fecbea8f909d674$var$_react = $8fecbea8f909d674$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8fecbea8f909d674$var$_baseNew = $8fecbea8f909d674$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $8fecbea8f909d674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8fecbea8f909d674$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $8fecbea8f909d674$var$_react.default.createElement($8fecbea8f909d674$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$8fecbea8f909d674$var$EyeOpenIcon.displayName = "EyeOpenIcon";
var $8fecbea8f909d674$var$_default = module.exports.default = $8fecbea8f909d674$var$EyeOpenIcon;

});

parcelRegister("jwsof", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e367072653dd9624$var$_react = $e367072653dd9624$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $e367072653dd9624$var$_baseNew = $e367072653dd9624$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $e367072653dd9624$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e367072653dd9624$var$FileIcon = (props)=>/*#__PURE__*/ $e367072653dd9624$var$_react.default.createElement($e367072653dd9624$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e367072653dd9624$var$FileIcon.displayName = "FileIcon";
var $e367072653dd9624$var$_default = module.exports.default = $e367072653dd9624$var$FileIcon;

});

parcelRegister("llWxg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8b8f712153f66c5$var$_react = $f8b8f712153f66c5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $f8b8f712153f66c5$var$_baseNew = $f8b8f712153f66c5$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $f8b8f712153f66c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8b8f712153f66c5$var$FeedbackIcon = (props)=>/*#__PURE__*/ $f8b8f712153f66c5$var$_react.default.createElement($f8b8f712153f66c5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$f8b8f712153f66c5$var$FeedbackIcon.displayName = "FeedbackIcon";
var $f8b8f712153f66c5$var$_default = module.exports.default = $f8b8f712153f66c5$var$FeedbackIcon;

});

parcelRegister("30lzE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23021b54e58d1b56$var$_react = $23021b54e58d1b56$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $23021b54e58d1b56$var$_baseNew = $23021b54e58d1b56$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $23021b54e58d1b56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23021b54e58d1b56$var$RoadmapIcon = (props)=>/*#__PURE__*/ $23021b54e58d1b56$var$_react.default.createElement($23021b54e58d1b56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$23021b54e58d1b56$var$RoadmapIcon.displayName = "RoadmapIcon";
var $23021b54e58d1b56$var$_default = module.exports.default = $23021b54e58d1b56$var$RoadmapIcon;

});

parcelRegister("j25Ho", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddb29fee3dff1f48$var$_react = $ddb29fee3dff1f48$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ddb29fee3dff1f48$var$_baseNew = $ddb29fee3dff1f48$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ddb29fee3dff1f48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddb29fee3dff1f48$var$EmojiIcon = (props)=>/*#__PURE__*/ $ddb29fee3dff1f48$var$_react.default.createElement($ddb29fee3dff1f48$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$ddb29fee3dff1f48$var$EmojiIcon.displayName = "EmojiIcon";
var $ddb29fee3dff1f48$var$_default = module.exports.default = $ddb29fee3dff1f48$var$EmojiIcon;

});

parcelRegister("8A4p1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63f519c8ab72f6bb$var$_react = $63f519c8ab72f6bb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $63f519c8ab72f6bb$var$_feedback = $63f519c8ab72f6bb$var$_interopRequireDefault((parcelRequire("llWxg")));
function $63f519c8ab72f6bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $63f519c8ab72f6bb$var$FeedbackIcon = (props)=>/*#__PURE__*/ $63f519c8ab72f6bb$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $63f519c8ab72f6bb$var$_feedback.default
    }));
$63f519c8ab72f6bb$var$FeedbackIcon.displayName = "FeedbackIcon";
var $63f519c8ab72f6bb$var$_default = module.exports.default = $63f519c8ab72f6bb$var$FeedbackIcon;

});

parcelRegister("aOabo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7de678fbce1024bb$var$_react = $7de678fbce1024bb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $7de678fbce1024bb$var$_roadmap = $7de678fbce1024bb$var$_interopRequireDefault((parcelRequire("30lzE")));
function $7de678fbce1024bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7de678fbce1024bb$var$RoadmapIcon = (props)=>/*#__PURE__*/ $7de678fbce1024bb$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $7de678fbce1024bb$var$_roadmap.default
    }));
$7de678fbce1024bb$var$RoadmapIcon.displayName = "RoadmapIcon";
var $7de678fbce1024bb$var$_default = module.exports.default = $7de678fbce1024bb$var$RoadmapIcon;

});

parcelRegister("foKoE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b35d164c36c1b05f$var$_react = $b35d164c36c1b05f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b35d164c36c1b05f$var$_baseNew = $b35d164c36c1b05f$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b35d164c36c1b05f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b35d164c36c1b05f$var$LightbulbIcon = (props)=>/*#__PURE__*/ $b35d164c36c1b05f$var$_react.default.createElement($b35d164c36c1b05f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$b35d164c36c1b05f$var$LightbulbIcon.displayName = "LightbulbIcon";
var $b35d164c36c1b05f$var$_default = module.exports.default = $b35d164c36c1b05f$var$LightbulbIcon;

});

parcelRegister("5XRUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04422a31fe921661fd3c15a462bdcae0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $457c47c57a91dbf4$var$_react = $457c47c57a91dbf4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $457c47c57a91dbf4$var$_baseNew = $457c47c57a91dbf4$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $457c47c57a91dbf4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $457c47c57a91dbf4$var$GlobeIcon = (props)=>/*#__PURE__*/ $457c47c57a91dbf4$var$_react.default.createElement($457c47c57a91dbf4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$457c47c57a91dbf4$var$GlobeIcon.displayName = "GlobeIcon";
var $457c47c57a91dbf4$var$_default = module.exports.default = $457c47c57a91dbf4$var$GlobeIcon;

});


var $e15Q8 = parcelRequire("e15Q8");

var $200NX = parcelRequire("200NX");

var $2A2ZL = parcelRequire("2A2ZL");

var $78sex = parcelRequire("78sex");
(0, $2A2ZL.init)((0, $e15Q8.ConfluenceTemplateDetailsRelayPage), (0, $78sex.ConfluenceTemplateDetailsRelayPageQuery), (0, $78sex.getConfluenceTemplateDetailsRelayPageQueryVars)(window.location), (0, $200NX.RELAY_API_CONTENTFUL));


//# sourceMappingURL=confluence-template-details-contentful-relay-page.312e7964.js.map
